import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IonInput, LoadingController } from '@ionic/angular';
import { AuthService } from 'src/app/core/authentication/services/auth.service';
import { SyncService } from 'src/app/core/sync/sync.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent {

	@ViewChild('autofocus', { static: false })
	autofocusInput: IonInput;

	@ViewChild('username', { static: false })
	username: IonInput;

	@ViewChild('password', { static: false })
	password: IonInput;

	isLoginInvalid: boolean;
	exceededMaxLoginAttempts: boolean;

	constructor(
		private router: Router,
		private authService: AuthService,
		private loadingController: LoadingController,
		private syncService: SyncService,
	) { }

	ionViewDidEnter() {
		this.autofocusInput.setFocus();
	}

	async onSubmitLogin() {
		this.isLoginInvalid = false;
		this.exceededMaxLoginAttempts = false;

		const username = (this.username.value as string);
		const password = (this.password.value as string);
		if (!username || !password) {
			this.isLoginInvalid = true;
			return;
		}

		const loadingPrompt = await this.presentLoadingPrompt();
		this.authService.login(username, password).subscribe(
			async _ => {
				this.clearForm();
				this.syncService.isBlockingSync$.next(true);
				this.syncService.sync(true);

				await loadingPrompt.dismiss();

				this.router.navigate(['appointments']);
			},
			(error) => {
				loadingPrompt.dismiss();

				if (error.status == 429) {
					this.exceededMaxLoginAttempts = true;
				} else {
					this.isLoginInvalid = true;
				}

				this.autofocusInput.setFocus();
			}
		);
	}

	clearForm() {
		this.username.value = '';
		this.password.value = '';
	}

	async presentLoadingPrompt() {
		const loadingPrompt = await this.loadingController.create({
			message: 'Logging in...'
		});
		await loadingPrompt.present();

		return loadingPrompt;
	}

	async alert(): Promise<HTMLIonLoadingElement> {
		return await this.loadingController.create({
			message: 'Syncing...'
		});
	}
}
